import { createLogger } from "utils/logging";
import { Cinema } from "../cinema-module/cinema";
import { scheduleCustomerIdVerification } from "../verify";

const log = createLogger("cinema", "pdp");
log.info("Initialize PdPCinema");

const root = document.getElementById("ft9_benefit_cinema__root");

const cinema = new Cinema();
cinema.init(1);

scheduleCustomerIdVerification("pdp", root);
